import { render } from "./HistoryVehicle.vue?vue&type=template&id=f5717288"
import script from "./HistoryVehicle.vue?vue&type=script&lang=js"
export * from "./HistoryVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script